export type DeviceOrientationValue = symbol;

export default {
  PORTRAIT: Symbol('portrait'),
  LANDSCAPE: Symbol('landscape')
} as const;
